import partnero from './partnero';
import config from "./config";

(function () {
    if (!window.partnero) {
        window.partnero = partnero;
        config.setCurrentScript(document.currentScript);
        window.onload = () => {
            partnero.ini();
        }
    }
})();
